import Vue from 'vue';
import moment from 'moment';
export default Vue.extend({
    name: 'innerTransfersTable',
    props: {
        id: {
            type: String
        },
        createdAt: {
            type: String,
            required: true
        },
        amount: {
            type: String,
            required: true
        },
        asset: {
            type: String,
            required: true
        },
        fromExchange: {
            type: String,
            required: true
        },
        toExchange: {
            type: String,
            required: true
        },
        network: {
            type: String,
            required: true
        },
        commission: {
            type: String,
            required: true
        },
        status: {
            type: Object,
            required: true
        }
    },
    computed: {
        recipient() {
            const fromExchange = this.$t('transfersPage.history.betweenExchanges.' + this.fromExchange);
            const toExchange = this.$t('transfersPage.history.betweenExchanges.' + this.toExchange);
            return `${fromExchange} →&nbsp;${toExchange}`;
        },
        datetime() {
            return moment(this.createdAt).format('DD.MM.YYYY HH:mm');
        },
        amountString() {
            return this.NS(this.amount).toFixed(8);
        },
        commissionAmountString() {
            return this.NS(this.commission).toFixed(8);
        },
        processedStatus() {
            const status = this.status.text;
            switch (status) {
                case 'created': {
                    return Object.assign(Object.assign({}, this.status), { iconName: 'transfer-created', statusText: this.$t('transfersPage.history.betweenExchanges.created'), status: status });
                }
                case 'securityCheck': {
                    return Object.assign(Object.assign({}, this.status), { iconName: 'transfer-progress', statusText: this.$t('transfersPage.history.betweenExchanges.securityCheck'), status: status });
                }
                case 'balanceCheck': {
                    return Object.assign(Object.assign({}, this.status), { iconName: 'transfer-progress', statusText: this.$t('transfersPage.history.betweenExchanges.balanceCheck', { exchange: this.status.statusExchange }), status: status });
                }
                case 'chargedFromAccount': {
                    return Object.assign(Object.assign({}, this.status), { iconName: 'transfer-progress', statusText: this.$t('transfersPage.history.betweenExchanges.chargedFromAccount', { exchange: this.status.statusExchange }), status: status });
                }
                case 'waitingConfirmation': {
                    return Object.assign(Object.assign({}, this.status), { iconName: 'transfer-progress', statusText: this.$t('transfersPage.history.betweenExchanges.waitingConfirmation', { exchange: this.status.statusExchange }), status: status });
                }
                case 'confirmed': {
                    return Object.assign(Object.assign({}, this.status), { iconName: 'transfer-progress', statusText: this.$t('transfersPage.history.betweenExchanges.confirmed', { exchange: this.status.statusExchange }), status: status });
                }
                case 'awaitingConfirmation': {
                    return Object.assign(Object.assign({}, this.status), { iconName: 'transfer-progress', statusText: this.$t('transfersPage.history.betweenExchanges.awaitingConfirmation', { exchange: this.status.statusExchange }), status: status });
                }
                case 'executed': {
                    return Object.assign(Object.assign({}, this.status), { iconName: 'transfer-success', statusText: this.$t('transfersPage.history.betweenExchanges.executed'), status: status });
                }
                default: {
                    return Object.assign(Object.assign({}, this.status), { iconName: 'transfer-error', statusText: this.$t('transfersPage.history.betweenExchanges.error'), status: 'error' });
                }
            }
        }
    }
});
